/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// const $window = $(window);
	// let windowWidth = $window.width();
	// // メディアクエリ
	// let mql = window.matchMedia('screen and (max-width: 1024px)');
	//preload
	(0, _module.preload)(); // toggleHeader
	
	(0, _module.toggleHeader)(); //pageTop
	
	(0, _module.pageTop)(); // //showMovie
	// import {showMovie} from "../include/module";
	// showMovie();
	// //showImg
	// import {showImg} from "../include/module";
	// showImg();
	//showAbout
	
	(0, _module.showAbout)(); //anchorLink
	
	(0, _module.anchorLink)();
	$(window).on('load', function () {
	  setTimeout(function () {
	    $('.js-loadingAnimation').addClass("is-animated");
	  }, 200);
	  scrollIndexAnime();
	  toggleBox();
	  tabSwitching();
	}); // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); //ページトップ出現
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Story',
	    triggerHook: 1,
	    offset: '100'
	  }).setClassToggle('#st-Top', 'st-Top-Show').addTo(controller); //メニュー出現
	
	  new ScrollMagic.Scene({
	    triggerElement: '.index-Story',
	    triggerHook: 0,
	    offset: '100'
	  }).setClassToggle('#st-Menu', 'st-Menu-Show') // .addIndicators({name: "1"})
	  .addTo(controller); // //アプリ誘導
	  // new ScrollMagic.Scene({
	  //   triggerElement:'.index-Story',
	  //   triggerHook: 1,
	  //   offset: '80'
	  // })
	  // .setClassToggle('#following', 'show')
	  // .addTo(controller);
	  // //アプリ誘導
	  // new ScrollMagic.Scene({
	  //   triggerElement:'.st-Footer',
	  //   triggerHook: 1,
	  //   offset: '80'
	  // })
	  // .setClassToggle('#following, #st-Top', 'hidden')
	  // .addTo(controller);
	  //　スクロールで発火系
	
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .95
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  }); // 背景
	
	  new ScrollMagic.Scene({
	    triggerElement: '#song',
	    duration: 1500 // triggerHook: .5,
	    // offset: '0'
	
	  }) // .setPin("#index-Song_Bg")
	  .on("progress", function (prog) {
	    // 使いたいシーンに対してprogressイベントを設定します
	    var p = prog.progress; // 0～1の値が入ってきます
	
	    anime({
	      targets: "#index-Song_Bg",
	      translateY: -p * 220,
	      elasticity: 0,
	      easing: 'linear'
	    });
	  }) // .setClassToggle(".scene-Rain_Notice_Txt, .scene-Rain_Notice_Date", "show")
	  // .addIndicators({name: "1"})
	  .addTo(controller);
	}; // ------------------------------------------------------------------------
	// toggleBox
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var toggleBox = function toggleBox() {
	  $(".toggle_Button").on("click", function () {
	    $(this).next().slideToggle(300);
	    $(this).toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// tabSwitching
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var tabSwitching = function tabSwitching() {
	  $(document).on('click', '.movie_Tab_Item', function () {
	    var targetid = $(this).data('movie');
	    var idx = $('.movie_Tab_Item').index(this);
	    $(this).addClass('current').siblings('.movie_Tab_Item').removeClass('current');
	    $(this).closest('.movie_Tab').next('.movie_Contents').find('.movie_Contents_Item').removeClass('is-show is-animation');
	    $('.movie_Contents_Item').eq(idx).addClass('is-show');
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.showAbout = exports.showImg = exports.showMovie = exports.pageTop = exports.toggleHeader = exports.preload = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu'); // var windowW       = $(window).width();
	// var windowH       = $(window).innerHeight();
	// var _isSP         = false;
	// var _isipad  = false;
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened'); // stHeaderLogo.classList.remove('opened');
	
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed'); // stHeaderLogo.classList.add('closed');
	
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children('').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// showImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var showImg = function showImg() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe'); // open
	
	  $('.js-Img').on('click', function () {
	    var dataID = $(this).attr('data-img');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //img append
	      $content.append('<img src="' + dataID + '">'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	}; // ------------------------------------------------------------------------
	// showAbout
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showImg = showImg;
	
	var showAbout = function showAbout() {
	  var $event = $('#about-Stage');
	  $('.js-about').on('click', function () {
	    var dataAbout = $(this).attr('data-about');
	    $('#about-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      // fadeIn
	      $event.stop().fadeIn(400);
	      $('#about-Box').addClass('show');
	      $('#' + dataAbout).addClass('show');
	      return false;
	    });
	  }); //close
	
	  $('#about-Box,#about-Box_Close').on('click', function () {
	    $('#about-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#about-Stage').css({
	        'display': 'none'
	      });
	      $('#about-Box').removeClass('show');
	      $('.about-Box_Txt').removeClass('show');
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showAbout = showAbout;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 50;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var __layer = $('.st-Container').attr('data-layer');
	
	  var linkSpeed = 700;
	  var linkAdjust = 0; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  }); //トップページ時ののヘッダーリンク
	
	  $(".header-link").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkHash = linkHref.replace("./", "");
	    var linkTarget = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
	    var linkPosition = linkTarget.offset().top;
	
	    if (headerFlag) {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	    }
	
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js